// ECharts draws on a canvas, which cannot take a Tailwind class, so the
// sf-neutral Tailwind colours are repeated here as hex values.
export const SF_NEUTRAL_LIGHTER_2 = '#d4d4d4'
export const SF_NEUTRAL_LIGHT_2 = '#737373'
export const SF_NEUTRAL_DARKER_1 = '#171717'

export const CHART_BLUE = '#5b9bd5'
